import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_rcvdagzk6f: FaireBrandEntity = {
  token: "b_rcvdagzk6f",
  type: "brand",
  name: "PHIVI BOX",
  avatarUrl:
    "https://cdn.faire.com/fastly/bf317b78e39eced8f5683c3c0b9514fc96933b002f3134c2d506bdacf27be57e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/99b071e37c8f37780dec8de09e7c56eb96539314047f4291be025690bd626eb0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bf317b78e39eced8f5683c3c0b9514fc96933b002f3134c2d506bdacf27be57e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/99b071e37c8f37780dec8de09e7c56eb96539314047f4291be025690bd626eb0.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 173,
  rating: 4.7,
  reviewCount: 133,
  isInsider: true,
  description:
    "TRUSTED BY MARRIOTT, COLUMBIA UNIVERSITY, SPOTIFY, THE CLOUD ONE HOTELS, FAB SCRAP, AND MORE\n\nFEATURED IN BUZZ FEED, THE SPRUCE EATS AND TASTE OF HOME\n\nBROOKLYN’S GOT FLAVOR, AND PLENTY OF IT. Flavors that originated around the world and evolved into something truly unique on our streets. PHIVI BOX is a celebration of Brooklyn’s power to transform the familiar into something extraordinary. If it’s Brooklyn it has to be the best. So when we tell you we’ve created the ultimate modern macaron, we mean it. Every flavor is an express train from wherever you are to the heartbeat of Brooklyn. We proudly source from our local community and draw inspiration for our unforgettable flavors from Brooklyn’s vibrant mix of cultures. We’re a team of artisanal pastry chefs who are laser focused on one thing – perfecting the macaron. We’ve mastered and improved the classic French technique of macaronage to create the ideal macaron cookie shells – a balance between crunchy and chewy that you have to taste to believe. France had its moment, but the best macarons on the planet are now made in Brooklyn.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:55.645Z",
    importedBy: "entity-db-cli",
  },
};
